<template>

    <div>

        <!-- page-heading -->
        <page-heading :show="true" pageTitle="NEWSLETTER-HEADLINE"></page-heading>


        <div class="columns">

            <div class="col-main">


                <tabs type="boxed" size="normal" :on-tab-click="tabCallback">

                    <!-- tab: NEWSLETTER -->
                    <tab-item :label="$t('NEWSLETTER-TAB-NEWSLETTER')">

                        <template v-if="newsletterSelected == null">
                            <newsletter-list :loading="isLoading" :newsletters="siteNewsletters" @select="selectNewsletter"></newsletter-list>
                        </template>

                        <template v-else>

                            <div class="returnToOverview" @click="selectNewsletter(null)">
                                <span class="icon"><i class="icon-ak-zurueck"></i></span>zurück zur Übersicht
                            </div>

                            <newsletter-detail :newsletter="newsletterSelected" @back="selectNewsletter(null)"></newsletter-detail>

                            <div class="returnToOverview" @click="selectNewsletter(null)">
                                <span class="icon"><i class="icon-ak-zurueck"></i></span>zurück zur Übersicht
                            </div>

                        </template>

                    </tab-item>

                    <!-- tab: RECIPIENTS -->
                    <tab-item :label="$t('NEWSLETTER-TAB-UPLOAD_RECIPIENTS')">
                      <newsletter-recipients v-if="activeTab==1"></newsletter-recipients>
                    </tab-item>

                </tabs>

            </div>


        </div>



    </div>


</template>



<script>

export default {

    components: {
        'newsletterDetail': () => import('./incl-siteNewsletter-single'),
        'newsletterList': () => import('./incl-siteNewsletter-list'),
        'newsletterRecipients': () => import('@/components/newsletter/incl-siteNewsletter-recipients')
    },

    watch: {

        newsletterSelected(newVal) {

            if(newVal == null) {
                this.siteNewsletters = null;
                this.fetchData();
            }

        },

    },

    data() {

        return {

            isLoading: true,

            activeTab: 0,
            newsletterSelected: null,

            siteNewsletters: null,
            // appendedFormData: [],

        }

    },

    computed: {

        siteId() {
            return this.activeUser.site.id;
        },

        newsletterStatus() {
			return this.$store.getters.getTermsByTaxonomy('NEWSLETTER_STATUS');
		}

    },

    created() {

        this.fetchData();

    },

    mounted() {


    },


    methods: {

        tabCallback(id) {

            this.activeTab = id;

        },

        selectNewsletter(newsletter) {

            this.newsletterSelected = newsletter;

        },

        fetchData() {

            this.isLoading = true;
            var self = this;

            this.axios.get(this.$config.api + 'newsletter?site='+this.siteId)
                .then(res=> {

                    // this.siteNewsletters = res.data.newsletter;
                    this.siteNewsletters = [];

                    for(var prop in res.data.newsletter) {
                        self.siteNewsletters.push(res.data.newsletter[prop]);
                    }

                    this.isLoading = false;

                })

        },



        fetchDataOUT() {

            this.isLoading = true;

            var self = this;


            function getNewsletter() {
                return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements&liteCatalogPageElement=1&filters[channel]=12&orderBy=newsletterElement.sortorder,newsletter.scheduleDate,siteNewsletterElement.sortorder');
            }

            function getSiteNewsletter() {
                return self.axios.get(self.$config.api + 'siteNewsletter?include=siteNewsletter.elements,siteNewsletterElement.products,siteNewsletterElementProduct.product&liteCatalogPageElement=1&filters[site]='+self.siteId+'&orderBy=siteNewsletterElement.sortorder');
            }

            // make the get request
            this.axios.all([getNewsletter(), getSiteNewsletter()])

                .then(self.axios.spread(function (mainNewsletter, siteNewsletter) {

                    // self.currentCatalogName = currentCatalog.data.catalog[0].displayName;

                    var newslettObj = {};

                    self.siteNewsletters = [];

                    mainNewsletter.data.newsletter.forEach(function(newsletter) {

                        newsletter.newsletter = newsletter.id;

                        // create our newsletterObj
                        var newslettObj = {};

                        newslettObj.name = newsletter.name;
                        newslettObj.scheduleDate = newsletter.scheduleDate;
                        newslettObj.channel = newsletter.channel;

                        // check if this is a custom newsletter
                        let foundIndex = siteNewsletter.data.siteNewsletter.findIndex(s => s.newsletter == newsletter.id);

                        if(foundIndex > -1) {

                            newslettObj.isOriginal = false;
                            newslettObj.id = siteNewsletter.data.siteNewsletter[foundIndex].id;
                            newslettObj.newsletter = newsletter.id;
                            newslettObj.site = siteNewsletter.data.siteNewsletter[foundIndex].site;
                            newslettObj.subject = siteNewsletter.data.siteNewsletter[foundIndex].subject;
                            newslettObj.salutation = siteNewsletter.data.siteNewsletter[foundIndex].salutation;
                            newslettObj.introText = siteNewsletter.data.siteNewsletter[foundIndex].introText;
                            newslettObj.additionalText = siteNewsletter.data.siteNewsletter[foundIndex].additionalText;
                            newslettObj.elements = siteNewsletter.data.siteNewsletter[foundIndex].elements;

                            newslettObj.elements.forEach(e => {

                                e.productSlots = [
                                    e.products.find(p => p.sortorder == 0),
                                    e.products.find(p => p.sortorder == 1),
                                    e.products.find(p => p.sortorder == 2)
                                ];

                            })


                        // if it isn't a custom newsletter yet, we load the default values
                        } else {

                            newslettObj.isOriginal = true;
                            newslettObj.id = newsletter.id;
                            newslettObj.newsletter = null;
                            newslettObj.subject = newsletter.name;
                            newslettObj.salutation = "";
                            newslettObj.introText = "";
                            newslettObj.additionalText = "";
                            newslettObj.elements = newsletter.elements;

                        }

                        self.siteNewsletters.push(newslettObj);

                    })


                    // self.appendedFormData.push({ site: self.siteId });
                    // self.appendedFormData.push({ newsletterId: newVal });

                    self.isLoading = false;

                })).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },


    }

}


</script>


<style lang="scss">

    .returnToOverview {
        margin: 0 0 25px 0;
        cursor: pointer;
    }

    .centered {
        max-width: 640px;
        margin: 0 auto;
    }


</style>
